// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2knQ0","inputWrap":"styles_inputWrap__1hYVL","input":"styles_input__1cv6p"};